import { RouteConfig } from 'vue-router';
import { PermissionTypeEnum } from '../Api';
import ShiftStations from './pages/ShiftStations.vue';

export default [
    {
        path: '/:tenantId/shift-stations',
        name: 'ShiftStations',
        component: ShiftStations,
        props: (route) => ({ tenantId: route.params.tenantId }),
        meta: {
            permissions: [PermissionTypeEnum.PerformAudit, PermissionTypeEnum.Response],
            checkLicence: true,
            title: 'menu.shiftStations',
        },
    },
] as RouteConfig[];
